import React from 'react';
import * as AlertDialog from '@radix-ui/react-alert-dialog';

type Props = React.PropsWithChildren;

export const CancelButton: React.FC<Props> = (props) => {
  return <AlertDialog.Cancel asChild>{props.children}</AlertDialog.Cancel>;
};
